import React, { createContext, useContext, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';

const AuthContext = createContext(null);

const SCRIPT_URL = process.env.REACT_APP_SCRIPT_URL;

async function lookupUser(email) {
  const res = await fetch(SCRIPT_URL, {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify({ action: 'getUserByEmail', email }),
  });
  const data = await res.json();
  return data.user;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('market_ops_user');
    if (saved) {
      try {
        setUser(JSON.parse(saved));
      } catch {
        localStorage.removeItem('market_ops_user');
      }
    }
    setLoading(false);
  }, []);

  async function handleGoogleSuccess(credentialResponse) {
    const decoded = jwtDecode(credentialResponse.credential);
    const email = decoded.email;
    try {
      const dbUser = await lookupUser(email);
      if (!dbUser || !dbUser.is_active) {
        return { success: false, error: `${email} is not authorized. Ask your admin to add you.` };
      }
      const userData = {
        email,
        name: decoded.name,
        picture: decoded.picture,
        role: dbUser.role,
        token: credentialResponse.credential,
      };
      setUser(userData);
      localStorage.setItem('market_ops_user', JSON.stringify(userData));
      return { success: true };
    } catch (e) {
      return { success: false, error: 'Login failed. Please try again.' };
    }
  }

  function logout() {
    setUser(null);
    localStorage.removeItem('market_ops_user');
  }

  function hasRole(...roles) {
    return user && roles.includes(user.role);
  }

  return (
    <AuthContext.Provider value={{ user, loading, handleGoogleSuccess, logout, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
